import tippy from 'tippy.js';

const dataList = document.querySelector('.m-data-attributes__data-list');
const dataContent = document.querySelector('.m-data-attributes__content');

function initDataPage() {

  const dataWrap = document.querySelector(".m-data-attributes__data-wrap");
  const searchBox = document.getElementById("m-data-attributes__search");
  const searchBoxExit = document.querySelector(".m-data-attributes__stop-search--desktop");
  const categories = document.querySelectorAll('.m-data-attributes__data-list-item');
  const contentContainers = document.querySelectorAll('.m-data-attributes__content');
  const navItems = document.querySelectorAll('.m-data-attributes__nav-item');
  const listItems = document.querySelectorAll('.m-data-attributes__content-row');
  const listItemsSearch = document.querySelectorAll('.m-data-attributes__content-row--search');
  const navContainers = document.querySelectorAll('.m-data-attributes__nav');
  let debounceTimer;
 
  const debounce = (time, evt) => {
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function() {
      search(evt.target.value);
    }, time)
  };

  categories.forEach((category) => {
    category.addEventListener('click', () => {
      openDataTab(category);
    });
  });

  navItems.forEach((nav_item) => {
    nav_item.addEventListener('click', () => {
      filterNavItem(nav_item);
    });
  });

  searchBoxExit.addEventListener('click', () => {
    resetSearchBox();
  })

  searchBox.addEventListener('keyup', (evt) => {
    debounce(400, evt);
  })

  function search(str) {

    var searchStr = str.toLowerCase();

    var nResults = 0;

    if(searchStr === '') {
      
      if(dataWrap.classList.contains('search-active')) {
        dataWrap.classList.remove('search-active');
      }

      resetSearchListItems();

      return;
    }

    if(!dataWrap.classList.contains('search-active')) {
      dataWrap.classList.add('search-active');
    }

    listItemsSearch.forEach((row) => {

      if(row.classList.contains('m-data-attributes__content-row--first')) {
        return;
      }

      var cells = row.querySelectorAll('div[data-searchable="1"]');

      if (cells.length === 0) {
        return;
      }

      var found = false;

      cells.forEach((cell) => {
        if(cell.textContent.toLowerCase().indexOf(searchStr) !== -1) {
          found = 1;
          return;
        }
      });

      if(found) {
        row.classList.remove('hidden');
      } else {
        row.classList.add('hidden');
      }

    });

    // if(nResults === 0) {
    //   document.querySelector('.m-data-attributes__content-row--first').style.display = 'none';
    //   document.querySelector('.m-data-attributes__content__no-results').style.display = 'block';
    // } else {
    //   document.querySelector('.m-data-attributes__content-row--first').style.display = 'block';
    //   document.querySelector('.m-data-attributes__content__no-results').style.display = 'hidden';
    // }
  }

  function openDataTab(element) {
    const type = element.dataset.select;

    contentContainers.forEach((evt) => {
      if (evt.dataset.tab == type) {
        evt.classList.add('active');
        } else if (evt.classList.contains('active')) {
        evt.classList.remove('active');
      }
    });

    categories.forEach((category) => {
      if (category !== element && category.classList.contains('active')) {
        category.classList.remove('active');
      }
    });

    navContainers.forEach((container) => {
      if (container.dataset.name === type) {
        container.classList.add('active');
      } else if (container.classList.contains('active')) {
        container.classList.remove('active');
      }
    });

    listItems.forEach((item) => {
      if (item.classList.contains('fix-border')) {
        item.classList.remove('fix-border');
      }
    });

    if (!element.classList.contains('active')) {
      element.classList.add('active');
    }

    resetListItems();
    resetNavItems();
  }

  function filterNavItem(nav_item) {
    if (nav_item.classList.contains('current')) {
      return;
    }

    navItems.forEach((item) => {
      if (item.classList.contains('current')) {
        item.classList.remove('current');
      }
    });

    nav_item.classList.add('current');

    const listFilter = nav_item.dataset.name;

    resetListItems();

    if (listFilter === 'all') {
      return;
    }

    listItems.forEach((item) => {
      if (!item.classList.contains(`filter-${listFilter}`) && !item.classList.contains('m-data-attributes__content-row--first')) {
        item.classList.add('hidden');
      }
    });

    checkBorder();
  }

  function resetSearchListItems() {
    listItemsSearch.forEach((item) => {
      if (item.classList.contains('fix-border')) {
        item.classList.remove('fix-border');
      }

      if (item.classList.contains('hidden')) {
        item.classList.remove('hidden');
      }
    });
  }

  function resetListItems() {
    listItems.forEach((item) => {
      if (item.classList.contains('fix-border')) {
        item.classList.remove('fix-border');
      }

      if (item.classList.contains('hidden')) {
        item.classList.remove('hidden');
      }
    });
  }

  function resetNavItems() {
    navItems.forEach((item) => {
      if (item.classList.contains('current')) {
        item.classList.remove('current');
      }

      if (item.dataset.name === 'all' && !item.classList.contains('m-data-attributes__content-row--first')) {
        item.classList.add('current');
      }
    });
  }

  function resetSearchBox() {
    searchBox.value = '';
    
    if(dataWrap.classList.contains('search-active')) {
      dataWrap.classList.remove('search-active');
    }

    resetSearchListItems();
  }

  const buttons = document.querySelectorAll('.e-tooltip-btn');

  Array.from(buttons).forEach((button) => {
    tippy(button, {
      content: button.getAttribute('data-tippy'),
      theme: 'light-border',
      trigger: 'click',
      offset: [0, 18],
    });
  });

  function checkBorder() {
    listItems.forEach((item) => {
      if (item.classList.contains('fix-border')) {
        item.classList.remove('fix-border');
      }
    });

    for (const el of listItems) {
      if (el.offsetParent !== null && !el.classList.contains('m-data-attributes__content-row--first')) {
        el.classList.add('fix-border');
        return;
      }
    }
  }
}

if (dataList && dataContent) {
  initDataPage();
}
